
import { Product } from "@/types/product";
import { ipxTS3ACFPRO } from "./ipx-ts3a-cf-pro";
import { ipxTX3AWP2C } from "./ipx-tx3a-wp-2-c";
import { ipxTC3AWP3PRO } from "./ipx-tc3a-wp3-pro";
import { ipxUC1ULTRA } from "./ipx-uc1-ultra";

export const ipxProducts: Product[] = [
  ipxTS3ACFPRO,
  ipxTX3AWP2C,
  ipxTC3AWP3PRO,
  ipxUC1ULTRA
];
